import {FC} from "react";
import {useMainTranslation} from "../../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {DeleteDialogButton} from "../../../../../../newShared/components/deleteDialogButton";
import {useReportDialogs} from "../../../hooks/useReportDialogs";
import {useReports} from "../../../hooks/useReports";

export const ArchiveReportDialog: FC = () => {
    const {t} = useMainTranslation('', {keyPrefix: 'pathReports.Dialogs'});

    const {archiveReport} = useReports();
    const {archiveReport: {
        reportId, name, isOpen, isLoading, setArchiveReportDialog
    }} = useReportDialogs();

    const handleClose = () => {setArchiveReportDialog({clear: true})}
    const handleConfirm = () => {reportId && name && archiveReport(reportId, name)}

    return (
        <DeleteDialogButton isOpen={isOpen} isLoading={isLoading}
                            title={t('Archive report')}
                            message={t("If you archive information about the report '{{name}}', you will not be able to restore it.", {name: name || 'NAME'})}
                            handleConfirm={handleConfirm}
                            handleClose={handleClose}
        />
    )
}
